import { SerializerOperator } from "./SerializerOperator.js";

export class Serializer<T extends object>{
  private operators: { [key: string]: SerializerOperator<never> };

  constructor(operators: { [key: string]: SerializerOperator<never> }) {
    this.operators = operators;
  }

  public serialize(data: T): {[key: string]: string} {
    const out: {[key: string]: string} = {};
    for (const key of Object.keys(data)) {
      const k = key as keyof T;
      const operator = this.operators[key];
      const value = data[k];
      if (!operator && value !== undefined && value !== null) {
        out[key] = String(value);
      } else if (operator && value !== undefined && value !== null) {
        out[key] = operator.format(value as never);
      }
    }
    return out;
  }
}
